import React from 'react';
import { AllieIconProps } from '../../..';
/* eslint-disable max-len */

export const AlertMenuMobileApp: React.FC<AllieIconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
      <path
        d="M28.5429 28H4.79037C3.25233 28 2.28989 26.3364 3.05655 25.0031L14.9328 4.3487C15.7018 3.01129 17.6314 3.01129 18.4005 4.3487L30.2767 25.0031C31.0434 26.3364 30.081 28 28.5429 28Z"
        stroke={props.color || '#51525C'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.6667 12V17.3333"
        stroke={props.color || '#51525C'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.6667 22.68L16.68 22.6651"
        stroke={props.color || '#51525C'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
